(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onlypads-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('op-collection-tabs')) {
    customElements.define('op-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if ('IntersectionObserver' in window) {
          this.previewObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              const image = entry.target.querySelector('.op-collection__image--hover');
              if (image) image.loading = 'eager';
              this.previewObserver.unobserve(entry.target);
            });
          }, {rootMargin:'200px'});
          this.querySelectorAll('.op-collection__image-link--swap').forEach(card => this.previewObserver.observe(card));
        }
        this.querySelectorAll('[data-op-collection-step]').forEach(button => {
          const panel=button.closest('[role="tabpanel"]');
          const grid=panel.querySelector('.op-collection__grid');
          if(!grid){button.parentElement.hidden=true;return;}
          const update=()=>{const image=grid.querySelector('.op-collection__image-link');if(image&&image.offsetHeight)panel.style.setProperty('--op-nav-y',(image.offsetTop+image.offsetHeight/2)+'px');const max=grid.scrollWidth-grid.clientWidth;button.disabled=Number(button.dataset.opCollectionStep)<0?grid.scrollLeft<=2:grid.scrollLeft>=max-2;button.parentElement.hidden=max<3;};
          button.addEventListener('click',()=>grid.scrollBy({left:Number(button.dataset.opCollectionStep)*grid.clientWidth*0.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
          grid.addEventListener('scroll',update,{passive:true});
          new ResizeObserver(update).observe(grid);
          update();
        });
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        const select = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
          });
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[role="tabpanel"]');
          const tab = tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
          if (tab) select(tab);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onlypads-custom-stage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('op-custom-stage')) {
    customElements.define('op-custom-stage', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.slides = Array.from(this.querySelectorAll('.op-custom__design'));
        this.index = 0;
        this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.slides.forEach((slide, index) => { slide.style.opacity = index === 0 ? '1' : '0'; slide.setAttribute('aria-hidden', String(index !== 0)); });
        const advance = () => {
          if (!this.paused && !document.hidden && this.slides.length > 1) {
            this.index = (this.index + 1) % this.slides.length;
            this.slides.forEach((slide, index) => { const active = index === this.index; slide.style.opacity = active ? '1' : '0'; slide.setAttribute('aria-hidden', String(!active)); });
          }
        };
        this.startTimer = setTimeout(() => { advance(); this.timer = setInterval(advance, 3000); }, 1000);
        this.sync();
      }
      sync() { this.dataset.paused = String(this.paused); }
      disconnectedCallback() { clearTimeout(this.startTimer); clearInterval(this.timer); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onlypads-product-quality"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('op-quality-slider')) {
  customElements.define('op-quality-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const rail = this.querySelector('.op-mat-details__grid');
      const cards = Array.from(this.querySelectorAll('.op-mat-details__card'));
      const prev = this.querySelector('[data-quality-prev]');
      const next = this.querySelector('[data-quality-next]');
      const position = this.querySelector('[data-quality-position]');
      if (!rail || !cards.length || !prev || !next || !position) return;
      const current = () => cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - rail.getBoundingClientRect().left) < Math.abs(cards[best].getBoundingClientRect().left - rail.getBoundingClientRect().left) ? index : best, 0);
      const update = () => {
        const index = current();
        prev.disabled = index === 0;
        next.disabled = index === cards.length - 1;
        position.textContent = (index + 1) + ' / ' + cards.length;
      };
      const move = (step) => {
        const index = Math.max(0, Math.min(cards.length - 1, current() + step));
        const offset = cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
        rail.scrollTo({left:offset, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      rail.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(update); }, {passive:true, signal});
      rail.addEventListener('keydown', (event) => {
        if (event.target !== rail || !matchMedia('(max-width:749px)').matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(rail);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onlypads-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('op-reviews')) {
    customElements.define('op-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const rail = this.querySelector('.op-reviews__rail');
        if (!rail) return;
        const cards = Array.from(this.querySelectorAll('.op-reviews__card'));
        const filters = Array.from(this.querySelectorAll('[data-source-filter]'));
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        cards.forEach(card => {
          card.addEventListener('mouseenter', () => { this.hovered = true; });
          card.addEventListener('mouseleave', () => { this.hovered = false; this.restartAutoplay?.(); });
        });
        const update = () => { previous.disabled = rail.scrollLeft <= 2; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; };
        filters.forEach(button => button.addEventListener('click', () => {
          filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          cards.forEach(card => { card.hidden = button.dataset.sourceFilter !== 'all' && card.dataset.source !== button.dataset.sourceFilter; });
          rail.scrollLeft = 0; update();
        }));
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          const card = cards.find(item => !item.hidden);
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap);
          rail.scrollBy({left:Number(button.dataset.direction) * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }));
        this.restartAutoplay = () => { clearInterval(this.autoplayTimer); this.autoplayTimer = setInterval(() => {
          if (this.hovered || document.hidden) return;
          const card = cards.find(item => !item.hidden);
          if (!card || rail.scrollWidth <= rail.clientWidth + 2) return;
          if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) {
            rail.scrollTo({left:0, behavior:'instant'});
          } else {
            const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap);
            rail.scrollBy({left:step, behavior:'smooth'});
          }
        }, 5000); };
        this.restartAutoplay();
        rail.addEventListener('scroll', update, {passive:true});
        this.observer = new ResizeObserver(update); this.observer.observe(rail); update();
      }
      disconnectedCallback() { clearInterval(this.autoplayTimer); this.observer?.disconnect(); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
